import SupportedContext from '@/types/SupportedContext';
import SupportedLocale from '@/types/SupportedLocale';
import SupportedCountry from '@/types/SupportedCountry';
import SupportedLayout from '@/types/SupportedLayout';

export default {
  country: SupportedCountry.DE,
  locale: SupportedLocale.DE_DE,
  searchContext: SupportedContext.ALL,
  increment: 12,
  categoriesIncrement: 5,
  productsIncrement: 8,
  externalIncrement: 5,
  activeLayout: SupportedLayout.GRID,
  sidebar: {
    filter: {
      optionsLimit: 4,
      limit: 3,
    },
  },
  impressionsBatchCounter: 8,
  displayFilters: true,
};
